import script from "./SelfieView.vue?vue&type=script&setup=true&lang=js"
export * from "./SelfieView.vue?vue&type=script&setup=true&lang=js"

import "./SelfieView.vue?vue&type=style&index=0&id=048d9833&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-048d9833"]])

export default __exports__